type CustomTranslations = { [key: string]: { [key: string]: string } };

interface SerializedDropdownOption {
  id?: string;
  'is-correct'?: boolean;
  'custom-translations': CustomTranslations;
  position: number;
  value: string;
}

export default class DropdownOption {
  declare id: string | null;
  declare isCorrect: boolean | undefined;
  declare position: number;
  declare value: string;

  declare customTranslations: { [key: string]: { [key: string]: string } };

  constructor(attrs: Record<string, unknown>) {
    this.id = (attrs['id'] as number | undefined)?.toString() || null;
    this.isCorrect = attrs['is-correct'] as boolean;
    this.position = (attrs['position'] as number) ?? null;
    this.value = (attrs['value'] as string) ?? '';
    this.customTranslations = (attrs['custom-translations'] as CustomTranslations) ?? {
      value: {},
    };
  }

  serialize(): SerializedDropdownOption {
    const serialized: SerializedDropdownOption = {
      'custom-translations': this.customTranslations,
      position: this.position,
      value: this.value,
    };
    if (this.id) {
      serialized['id'] = this.id;
    }
    if (this.isCorrect !== undefined) {
      serialized['is-correct'] = this.isCorrect;
    }
    return serialized;
  }
}
